export const quickCategories = [
  {
    type: '电影',
    label: '电影',
    desc: '院线大片 · 经典佳片',
    icon: 'ri-film-line',
    count: 8,
  },
  {
    type: '电视剧',
    label: '电视剧',
    desc: '热播剧集 · 追剧不停',
    icon: 'ri-tv-2-line',
    count: 8,
  },
  {
    type: '综艺',
    label: '综艺',
    desc: '音乐竞技 · 生活纪实',
    icon: 'ri-mic-line',
    count: 8,
  },
];

export const filterOptions = {
  regions: ['全部', '中国', '美国', '韩国', '日本', '意大利'],
  years: ['全部', '2024', '2023', '2022'],
  genres: [
    '全部',
    '科幻',
    '悬疑',
    '动作',
    '剧情',
    '爱情',
    '古装',
    '都市',
    '罪案',
    '年代',
    '谍战',
    '职场',
    '音乐',
    '竞技',
    '生活',
    '推理',
    '脱口秀',
  ],
  sorts: ['最新更新', '最热播放', '评分最高'],
};

export const movies = [
  {
    id: 1,
    title: '星际迷航：新生',
    type: '电影',
    genres: ['科幻', '冒险'],
    region: '美国',
    year: 2024,
    director: '亚伦·凯斯勒',
    actors: ['艾米莉亚·罗森', '丹尼尔·福特', '凯文·马歇尔'],
    rating: 8.7,
    views: 1286000,
    description:
      '一支深入银河边缘的探索舰队意外唤醒沉睡数百年的古老文明，船员们必须在归途与真相之间做出抉择。影片以宏大的宇宙视效与紧凑的叙事节奏，讲述人类在未知面前重新理解“家园”二字的旅程。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%20of%20a%20lone%20spaceship%20gliding%20through%20a%20deep%20blue%20nebula%20with%20distant%20glowing%20planets%2C%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20orange%20accents%2C%20stylized%20minimal%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20spacescape%20with%20a%20massive%20starship%20silhouette%20against%20a%20deep%20navy%20nebula%20and%20orbiting%20planets%2C%20subtle%20warm%20orange%20light%20rim%2C%20stylized%20atmospheric%20illustration%2C%20dark%20tones%20suitable%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=hero-91ds-01&orientation=landscape',
    episodes: 1,
    duration: '128分钟',
    updatedAt: '2024-10-08',
    featured: true,
  },
  {
    id: 2,
    title: '长安夜行',
    type: '电影',
    genres: ['古装', '悬疑'],
    region: '中国',
    year: 2024,
    director: '陈砚舟',
    actors: ['林则言', '苏挽', '周听澜'],
    rating: 8.4,
    views: 1102000,
    description:
      '长安城连发奇案，一名少年捕快循着灯笼照不到的暗处追查真相，却在层层谜团里触碰到一场关于权谋与人心的巨大棋局。影片以盛唐夜色为舞台，把东方悬疑氛围推向极致。',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mystery%20movie%20poster%20of%20a%20lantern-lit%20Tang%20dynasty%20city%20at%20night%20with%20a%20cloaked%20figure%20walking%20a%20narrow%20alley%2C%20deep%20blue%20shadows%20and%20warm%20amber%20lantern%20light%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Atmospheric%20night%20scene%20of%20an%20ancient%20Chinese%20city%20street%20glowing%20with%20red%20lanterns%20under%20a%20deep%20blue%20sky%2C%20misty%20moody%20lighting%2C%20stylized%20artistic%20illustration%20with%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=hero-91ds-02&orientation=landscape',
    episodes: 1,
    duration: '116分钟',
    updatedAt: '2024-10-06',
    featured: true,
  },
  {
    id: 3,
    title: '追风者',
    type: '电影',
    genres: ['动作', '剧情'],
    region: '中国',
    year: 2023,
    director: '高远',
    actors: ['程亦风', '卢森', '叶知秋'],
    rating: 7.9,
    views: 986000,
    description:
      '一名退役车手被迫重返地下赛场，为了守护弟弟与曾经的热爱，他在城市的夜色里与时间竞速。油门与心跳之间，是一场关于救赎与坚持的较量。',
    cover:
      'https://readdy.ai/api/search-image?query=High-energy%20action%20movie%20poster%20of%20a%20race%20car%20speeding%20through%20a%20neon-lit%20city%20at%20night%20with%20motion%20blur%2C%20deep%20navy%20background%20and%20vivid%20orange%20light%20streaks%2C%20stylized%20dynamic%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dynamic%20night%20city%20highway%20scene%20with%20light%20trails%20from%20fast%20cars%2C%20deep%20blue%20urban%20skyline%20and%20warm%20orange%20highlights%2C%20cinematic%20stylized%20illustration%20with%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=hero-91ds-03&orientation=landscape',
    episodes: 1,
    duration: '104分钟',
    updatedAt: '2024-09-28',
    featured: false,
  },
  {
    id: 4,
    title: '深海回响',
    type: '电影',
    genres: ['悬疑', '惊悚'],
    region: '中国',
    year: 2024,
    director: '沈立',
    actors: ['顾清淮', '温如故', '维嘉'],
    rating: 8.1,
    views: 872000,
    description:
      '一支海洋科考队在万米深处接收到一段无法解释的信号。随着下潜越来越深，队员们的记忆与恐惧开始交织，真相在幽暗的水压中缓缓浮现。',
    cover:
      'https://readdy.ai/api/search-image?query=Suspenseful%20movie%20poster%20of%20a%20submersible%20diving%20into%20the%20dark%20deep%20ocean%2C%20faint%20glowing%20light%20in%20murky%20deep%20blue%20water%2C%20isolated%20eerie%20mood%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Underwater%20deep%20sea%20scene%20with%20light%20rays%20piercing%20dark%20blue%20water%20above%20a%20small%20submersible%2C%20mysterious%20atmospheric%20stylized%20illustration%20with%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=hero-91ds-04&orientation=landscape',
    episodes: 1,
    duration: '112分钟',
    updatedAt: '2024-10-02',
    featured: false,
  },
  {
    id: 5,
    title: '城市之光',
    type: '电影',
    genres: ['剧情', '都市'],
    region: '中国',
    year: 2023,
    director: '许南',
    actors: ['方宁', '陆一鸣', '乔楚'],
    rating: 7.6,
    views: 654000,
    description:
      '三个在城市里各自奔忙的普通人，因为一间深夜还亮着灯的洗衣店而相遇。影片用细腻的镜头记录平凡人生里的善意与微光。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20urban%20drama%20movie%20poster%20of%20a%20glowing%20laundromat%20window%20on%20a%20rainy%20city%20street%20at%20night%2C%20deep%20blue%20rain%20and%20soft%20orange%20interior%20light%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20warm%20glowing%20shop%20windows%20reflected%20on%20wet%20asphalt%2C%20deep%20blue%20ambient%20tones%20with%20orange%20highlights%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-05&orientation=landscape',
    episodes: 1,
    duration: '98分钟',
    updatedAt: '2024-09-20',
    featured: false,
  },
  {
    id: 6,
    title: '雪国列车',
    type: '电影',
    genres: ['灾难', '科幻'],
    region: '韩国',
    year: 2022,
    director: '朴正勋',
    actors: ['李承宇', '姜敏书', '尹相赫'],
    rating: 8.0,
    views: 720000,
    description:
      '地表冰封之后，幸存者在一列永不停歇的列车上延续文明。当车厢间的平衡被打破，一场关于秩序与自由的博弈在极寒中爆发。',
    cover:
      'https://readdy.ai/api/search-image?query=Post-apocalyptic%20movie%20poster%20of%20a%20long%20train%20crossing%20a%20frozen%20snowy%20wasteland%20under%20a%20cold%20blue%20sky%2C%20lonely%20and%20vast%20mood%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Vast%20frozen%20snowy%20landscape%20with%20a%20long%20train%20cutting%20through%20under%20a%20deep%20blue%20dusk%20sky%2C%20cold%20atmospheric%20stylized%20illustration%20with%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=hero-91ds-06&orientation=landscape',
    episodes: 1,
    duration: '126分钟',
    updatedAt: '2024-09-12',
    featured: false,
  },
  {
    id: 7,
    title: '时光信笺',
    type: '电影',
    genres: ['爱情', '剧情'],
    region: '日本',
    year: 2024,
    director: '中村遥',
    actors: ['佐藤一花', '山田凉太', '栗原桃'],
    rating: 8.3,
    views: 588000,
    description:
      '一个小镇的旧邮局里，凡是被投进红色邮箱的信都能寄往过去。两个素未谋面的人通过一封封跨越时间的信笺，慢慢靠近彼此。',
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20of%20a%20red%20post%20box%20and%20flying%20paper%20letters%20in%20a%20soft%20town%20street%20at%20golden%20dusk%2C%20gentle%20warm%20orange%20and%20muted%20blue%20tones%2C%20delicate%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20small%20town%20street%20at%20golden%20dusk%20with%20paper%20letters%20drifting%20in%20the%20warm%20breeze%2C%20soft%20orange%20light%20and%20muted%20blue%20shadows%2C%20gentle%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-07&orientation=landscape',
    episodes: 1,
    duration: '108分钟',
    updatedAt: '2024-10-05',
    featured: false,
  },
  {
    id: 8,
    title: '荒野猎人',
    type: '电影',
    genres: ['冒险', '动作'],
    region: '美国',
    year: 2023,
    director: '罗伯特·凯恩',
    actors: ['杰克·哈珀', '娜塔莉·伍德', '伊桑·布莱克'],
    rating: 7.8,
    views: 612000,
    description:
      '一名向导在落基山脉的暴风雪中与队伍失散，仅凭一把猎刀和顽强的意志穿越荒野。影片用近乎白描的镜头，刻画人与自然最原始的对抗。',
    cover:
      'https://readdy.ai/api/search-image?query=Rugged%20wilderness%20adventure%20movie%20poster%20of%20a%20lone%20figure%20with%20a%20knife%20facing%20a%20misty%20snowy%20mountain%20forest%2C%20cold%20blue%20tones%20and%20warm%20campfire%20glow%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-08&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dramatic%20snowy%20mountain%20wilderness%20during%20a%20blizzard%20with%20towering%20pine%20trees%2C%20cold%20blue%20mist%20and%20a%20faint%20warm%20horizon%20glow%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-08&orientation=landscape',
    episodes: 1,
    duration: '134分钟',
    updatedAt: '2024-09-15',
    featured: false,
  },
  {
    id: 9,
    title: '山河故人梦',
    type: '电视剧',
    genres: ['古装', '剧情'],
    region: '中国',
    year: 2024,
    director: '郑砚',
    actors: ['萧承玉', '沈明月', '顾长风'],
    rating: 8.6,
    views: 1560000,
    description:
      '乱世之中，一位出身寒门的书生凭借过人才识一步步走入朝堂，在权谋与人情的漩涡里坚守初心。全剧以恢弘的群像叙事，铺陈一幅山河画卷。',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20Chinese%20costume%20drama%20poster%20of%20a%20scholar%20in%20flowing%20robes%20standing%20before%20ancient%20palace%20roofs%20under%20a%20blue%20dusk%20sky%2C%20warm%20golden%20accents%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sweeping%20ancient%20Chinese%20palace%20landscape%20at%20dusk%20with%20layered%20rooftops%20and%20misty%20mountains%2C%20deep%20blue%20sky%20and%20warm%20golden%20light%2C%20stylized%20cinematic%20illustration%20with%20dark%20tones%20for%20text%20overlay%2C%20no%20text&width=1600&height=900&seq=hero-91ds-09&orientation=landscape',
    episodes: 42,
    duration: '45分钟/集',
    updatedAt: '2024-10-09',
    featured: true,
  },
  {
    id: 10,
    title: '都市迷情',
    type: '电视剧',
    genres: ['都市', '爱情'],
    region: '中国',
    year: 2024,
    director: '何亦然',
    actors: ['宋清欢', '高牧野', '白露'],
    rating: 7.7,
    views: 1320000,
    description:
      '两位在职场中并肩作战的年轻人，在理想与现实之间反复拉扯。剧集聚焦当代都市情感，既有甜蜜也有成长。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20of%20a%20young%20couple%20silhouetted%20against%20a%20city%20skyline%20at%20night%2C%20deep%20blue%20tones%20with%20warm%20orange%20bokeh%20lights%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-10&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=City%20skyline%20at%20night%20with%20glowing%20office%20towers%20and%20warm%20street%20lights%2C%20deep%20blue%20ambient%20tones%20with%20orange%20accents%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-10&orientation=landscape',
    episodes: 36,
    duration: '45分钟/集',
    updatedAt: '2024-10-07',
    featured: false,
  },
  {
    id: 11,
    title: '白夜追踪',
    type: '电视剧',
    genres: ['悬疑', '罪案'],
    region: '中国',
    year: 2023,
    director: '谷一鸣',
    actors: ['谢临', '陆雪', '方可'],
    rating: 8.5,
    views: 1490000,
    description:
      '一桩尘封多年的旧案重新浮出水面，刑警队长与法医联手，在黑白颠倒的迷雾中抽丝剥茧。剧集节奏紧凑，案件环环相扣。',
    cover:
      'https://readdy.ai/api/search-image?query=Crime%20thriller%20series%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20under%20a%20single%20street%20lamp%20in%20heavy%20rain%2C%20deep%20blue%20noir%20tones%20%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-11&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Moody%20rainy%20city%20alley%20at%20night%20with%20a%20single%20glowing%20street%20lamp%20and%20wet%20reflective%20ground%2C%20deep%20blue%20noir%20atmosphere%20with%20a%20faint%20orange%20glow%2C%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-11&orientation=landscape',
    episodes: 32,
    duration: '45分钟/集',
    updatedAt: '2024-09-25',
    featured: false,
  },
  {
    id: 12,
    title: '海上繁花',
    type: '电视剧',
    genres: ['年代', '剧情'],
    region: '中国',
    year: 2023,
    director: '钟雅',
    actors: ['裴知微', '霍之遥', '林书白'],
    rating: 8.2,
    views: 1180000,
    description:
      '上世纪三十年代的上海，一位千金小姐在家道中落后独自谋生，与命运几番交手。剧集以精致的美术还原旧日风华。',
    cover:
      'https://readdy.ai/api/search-image?query=Retro%20Shanghai%20period%20drama%20poster%20of%20an%20elegant%20woman%20in%20a%20cheongsam%20by%20a%20rainy%20window%2C%20muted%20blue%20and%20warm%20amber%20tones%2C%20stylized%20vintage%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Retro%201930s%20Shanghai%20street%20scene%20with%20old%20trams%20and%20neon%20signs%20at%20dusk%2C%20muted%20blue%20tones%20with%20warm%20amber%20light%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-12&orientation=landscape',
    episodes: 40,
    duration: '45分钟/集',
    updatedAt: '2024-09-18',
    featured: false,
  },
  {
    id: 13,
    title: '破晓行动',
    type: '电视剧',
    genres: ['谍战', '悬疑'],
    region: '中国',
    year: 2024,
    director: '梁子墨',
    actors: ['沈砚', '苏婉宁', '江澈'],
    rating: 8.4,
    views: 1360000,
    description:
      '风雨飘摇的年代，一名潜伏在敌营深处的地下工作者，在刀尖上传递着关乎战局的情报。每一次呼吸都可能是最后一次。',
    cover:
      'https://readdy.ai/api/search-image?query=Spy%20thriller%20drama%20poster%20of%20a%20man%20in%20a%20long%20coat%20and%20hat%20walking%20a%20foggy%20old%20city%20street%20at%20dawn%2C%20deep%20blue%20muted%20tones%20with%20faint%20orange%20sunrise%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-13&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Foggy%20old%20city%20street%20at%20dawn%20with%20a%20lone%20figure%20in%20a%20coat%2C%20deep%20blue%20mist%20and%20a%20faint%20warm%20sunrise%20glow%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-13&orientation=landscape',
    episodes: 30,
    duration: '45分钟/集',
    updatedAt: '2024-10-04',
    featured: false,
  },
  {
    id: 14,
    title: '医者仁心',
    type: '电视剧',
    genres: ['职场', '剧情'],
    region: '中国',
    year: 2022,
    director: '谭沐',
    actors: ['季川', '许安然', '陈知远'],
    rating: 7.9,
    views: 940000,
    description:
      '一群年轻医生在急诊科的日与夜里，直面生死考验与职业成长。剧集以真实细腻的笔触，致敬每一位白衣执甲的人。',
    cover:
      'https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20young%20doctors%20in%20white%20coats%20in%20a%20bright%20hospital%20corridor%20at%20night%2C%20clean%20blue-white%20tones%20with%20warm%20accents%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-14&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Modern%20hospital%20corridor%20at%20night%20with%20soft%20glowing%20lights%20and%20clean%20lines%2C%20cool%20blue%20tones%20with%20warm%20highlights%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-14&orientation=landscape',
    episodes: 38,
    duration: '45分钟/集',
    updatedAt: '2024-09-10',
    featured: false,
  },
  {
    id: 15,
    title: '硅谷风云',
    type: '电视剧',
    genres: ['剧情', '职场'],
    region: '美国',
    year: 2023,
    director: '马克·斯蒂文',
    actors: ['大卫·科尔', '艾拉·格林', '汤姆·里德'],
    rating: 8.1,
    views: 860000,
    description:
      '一家濒临倒闭的初创公司，因为一个疯狂的想法起死回生。剧集以辛辣的幽默揭开科技行业光鲜背后的真实生态。',
    cover:
      'https://readdy.ai/api/search-image?query=Tech%20drama%20poster%20of%20a%20modern%20startup%20office%20with%20glowing%20monitors%20and%20glass%20walls%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20accent%20light%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20at%20night%20with%20glass%20walls%20and%20glowing%20screens%2C%20deep%20blue%20ambient%20tones%20with%20orange%20highlights%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-15&orientation=landscape',
    episodes: 24,
    duration: '40分钟/集',
    updatedAt: '2024-09-22',
    featured: false,
  },
  {
    id: 16,
    title: '我的天才女友',
    type: '电视剧',
    genres: ['剧情', '年代'],
    region: '意大利',
    year: 2022,
    director: '卢卡·费拉拉',
    actors: ['玛尔塔·里瓦', '吉亚达·卢卡', '保罗·马里'],
    rating: 8.8,
    views: 720000,
    description:
      '那不勒斯的老城区里，两个女孩从童年到青年的友谊与竞争，映照出一代人的成长与时代的变迁。',
    cover:
      'https://readdy.ai/api/search-image?query=Coming%20of%20age%20drama%20poster%20of%20two%20girls%20standing%20in%20a%20narrow%20old%20European%20alley%2C%20warm%20sunlit%20muted%20tones%20with%20deep%20blue%20shadows%2C%20stylized%20vintage%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-16&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20European%20neighborhood%20alley%20at%20golden%20hour%20with%20laundry%20lines%20and%20terracotta%20walls%2C%20warm%20muted%20tones%20with%20deep%20blue%20shadows%2C%20stylized%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-16&orientation=landscape',
    episodes: 16,
    duration: '50分钟/集',
    updatedAt: '2024-09-08',
    featured: false,
  },
  {
    id: 17,
    title: '热血舞台',
    type: '综艺',
    genres: ['音乐', '竞技'],
    region: '中国',
    year: 2024,
    director: '综艺制作组',
    actors: ['吴宇航', '苏念', '郑可欣'],
    rating: 8.3,
    views: 1050000,
    description:
      '来自不同领域的唱将同台竞演，用一首首改编舞台点燃全场。节目以高水准的音乐制作与舞美呈现，成为年度热议的音乐竞演。',
    cover:
      'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20singer%20silhouetted%20on%20a%20dramatic%20concert%20stage%20with%20spotlights%20and%20smoke%2C%20deep%20blue%20and%20vivid%20orange%20stage%20lights%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-17&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dramatic%20concert%20stage%20with%20spotlights%20beams%20and%20smoke%20above%20a%20cheering%20crowd%2C%20deep%20blue%20and%20warm%20orange%20stage%20lighting%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-17&orientation=landscape',
    episodes: 12,
    duration: '90分钟/期',
    updatedAt: '2024-10-10',
    featured: true,
  },
  {
    id: 18,
    title: '快乐大本营',
    type: '综艺',
    genres: ['综艺', '竞技'],
    region: '中国',
    year: 2024,
    director: '综艺制作组',
    actors: ['何云', '谢可', '李维'],
    rating: 7.4,
    views: 980000,
    description:
      '经典周播综艺持续带来轻松欢乐，明星嘉宾游戏互动、才艺展示，陪伴观众度过每一个周末夜晚。',
    cover:
      'https://readdy.ai/api/search-image?query=Cheerful%20variety%20show%20poster%20of%20a%20colorful%20studio%20stage%20with%20confetti%20and%20bright%20lights%2C%20playful%20deep%20blue%20and%20warm%20orange%20tones%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-18&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Colorful%20tv%20studio%20stage%20with%20confetti%20and%20glowing%20lights%2C%20playful%20blue%20and%20orange%20tones%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-18&orientation=landscape',
    episodes: 52,
    duration: '90分钟/期',
    updatedAt: '2024-10-11',
    featured: false,
  },
  {
    id: 19,
    title: '向往的生活',
    type: '综艺',
    genres: ['生活', '综艺'],
    region: '中国',
    year: 2023,
    director: '综艺制作组',
    actors: ['黄知味', '彭一凡', '张子枫'],
    rating: 8.0,
    views: 870000,
    description:
      '几位老朋友回到乡野小院，种菜做饭、招待来客，在一日三餐里体味最朴素的幸福。慢综艺治愈系代表作。',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20slow%20life%20variety%20show%20poster%20of%20a%20rustic%20countryside%20courtyard%20with%20warm%20lanterns%20at%20dusk%2C%20green%20and%20warm%20orange%20tones%20with%20deep%20blue%20sky%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-19&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20village%20at%20dusk%20with%20warm%20lit%20cottages%20and%20green%20fields%2C%20soft%20blue%20evening%20sky%20with%20orange%20glow%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-19&orientation=landscape',
    episodes: 14,
    duration: '90分钟/期',
    updatedAt: '2024-09-30',
    featured: false,
  },
  {
    id: 20,
    title: '明星大侦探',
    type: '综艺',
    genres: ['推理', '综艺'],
    region: '中国',
    year: 2024,
    director: '综艺制作组',
    actors: ['撒贝', '何云', '白敬'],
    rating: 8.5,
    views: 1020000,
    description:
      '嘉宾化身剧中角色，在一场场精心设计的推理谜局中寻找真相。烧脑剧情与幽默互动兼具，备受观众喜爱。',
    cover:
      'https://readdy.ai/api/search-image?query=Mystery%20detective%20variety%20show%20poster%20of%20a%20magnifying%20glass%20and%20fingerprint%20motifs%20over%20a%20dim%20stage%2C%20deep%20blue%20noir%20tones%20with%20orange%20accent%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-20&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dim%20theatrical%20stage%20with%20mysterious%20props%20and%20spotlights%2C%20deep%20blue%20noir%20atmosphere%20with%20a%20warm%20orange%20glow%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-20&orientation=landscape',
    episodes: 14,
    duration: '100分钟/期',
    updatedAt: '2024-10-09',
    featured: false,
  },
  {
    id: 21,
    title: '奔跑吧兄弟',
    type: '综艺',
    genres: ['竞技', '综艺'],
    region: '中国',
    year: 2023,
    director: '综艺制作组',
    actors: ['邓超', '陈赫', '郑恺'],
    rating: 7.6,
    views: 760000,
    description:
      '跑男团集结出发，在城市与山水之间展开一场场体力与智慧的较量，团队协作与欢乐氛围贯穿始终。',
    cover:
      'https://readdy.ai/api/search-image?query=Energetic%20outdoor%20competition%20variety%20poster%20of%20runners%20racing%20across%20a%20dynamic%20landscape%20with%20motion%20streaks%2C%20vivid%20blue%20and%20orange%20tones%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-21&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dynamic%20outdoor%20landscape%20with%20motion%20streaks%20suggesting%20speed%20and%20running%2C%20vivid%20blue%20sky%20and%20warm%20orange%20accents%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-21&orientation=landscape',
    episodes: 12,
    duration: '100分钟/期',
    updatedAt: '2024-09-26',
    featured: false,
  },
  {
    id: 22,
    title: '中国好声音',
    type: '综艺',
    genres: ['音乐', '竞技'],
    region: '中国',
    year: 2022,
    director: '综艺制作组',
    actors: ['那英', '汪峰', '李荣浩'],
    rating: 7.8,
    views: 690000,
    description:
      '四位导师背对选手聆听歌声，以声音决定转身。舞台见证无数平凡人用热爱唱响属于自己的高光时刻。',
    cover:
      'https://readdy.ai/api/search-image?query=Singing%20competition%20show%20poster%20of%20a%20lone%20singer%20under%20a%20dramatic%20spotlight%20on%20a%20dark%20stage%2C%20deep%20blue%20background%20with%20warm%20orange%20beam%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-22&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Dark%20empty%20stage%20with%20a%20single%20dramatic%20spotlight%20and%20elegant%20curtains%2C%20deep%20blue%20tones%20with%20warm%20orange%20beam%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-22&orientation=landscape',
    episodes: 14,
    duration: '95分钟/期',
    updatedAt: '2024-09-14',
    featured: false,
  },
  {
    id: 23,
    title: '这就是街舞',
    type: '综艺',
    genres: ['竞技', '音乐'],
    region: '中国',
    year: 2024,
    director: '综艺制作组',
    actors: ['王一博', '张艺兴', '韩庚'],
    rating: 8.4,
    views: 910000,
    description:
      '顶尖舞者同台竞技，用身体讲述节奏与态度。节目以震撼的团队大秀与个人battle，掀起街舞热潮。',
    cover:
      'https://readdy.ai/api/search-image?query=Street%20dance%20competition%20poster%20of%20a%20dancer%20mid-move%20under%20neon%20stage%20lights%20with%20urban%20backdrop%2C%20vivid%20deep%20blue%20and%20orange%20tones%2C%20stylized%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-23&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Urban%20street%20dance%20stage%20with%20neon%20lights%20and%20graffiti%20walls%2C%20vivid%20deep%20blue%20and%20warm%20orange%20tones%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-23&orientation=landscape',
    episodes: 12,
    duration: '100分钟/期',
    updatedAt: '2024-10-03',
    featured: false,
  },
  {
    id: 24,
    title: '语言的魅力',
    type: '综艺',
    genres: ['脱口秀', '综艺'],
    region: '中国',
    year: 2023,
    director: '综艺制作组',
    actors: ['李诞', '呼兰', '徐志胜'],
    rating: 8.2,
    views: 640000,
    description:
      '一群脱口秀演员用五分钟的段子拆解生活百态，在欢笑中说出你我都懂的共鸣。语言类节目口碑之作。',
    cover:
      'https://readdy.ai/api/search-image?query=Talk%20show%20poster%20of%20a%20microphone%20on%20a%20stand%20on%20a%20simple%20stage%20with%20a%20warm%20spotlight%2C%20deep%20blue%20background%20and%20orange%20accent%2C%20stylized%20minimal%20illustration%2C%20no%20text&width=600&height=900&seq=cover-91ds-24&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Intimate%20small%20comedy%20club%20stage%20with%20a%20single%20microphone%20in%20warm%20spotlight%2C%20deep%20blue%20background%20with%20orange%20glow%2C%20stylized%20cinematic%20illustration%2C%20no%20text&width=1600&height=900&seq=hero-91ds-24&orientation=landscape',
    episodes: 12,
    duration: '80分钟/期',
    updatedAt: '2024-09-16',
    featured: false,
  },
];